import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import style from "css/workspace.module.css";
import NotFound from "pages/common/notFound";
import "css/ant.css";
import Presentation from "pages/space/workspace/detail/presentation";

function ClickshareMain() {
  return (
    <div className={style.fontsize}>
      <Routes>
        <Route
          path=""
          element={<Presentation />}
        />
        <Route
          path="*"
          element={
            <Navigate
              to={process.env.REACT_APP_CLIENT_URL}
              replace
            />
          }
        />
      </Routes>
    </div>
  );
}

export default ClickshareMain;
